import Program from "./views/Program/Create";
import Dashboard from "./views/Dashboard";
// import changePass from './views/Changepass'
import Approval from "./views/Program/Approval";
import Summary from "./views/Program/Summary";
import ApprovalDetail from "./views/Program/ApprovalDetail";
import SummaryDetail from "./views/Program/SummaryDetail";
import Member from "./views/Program/Member";

import UpdateBudget from "./views/Program/UpdateBudget";
import UpdateBudgetDetail from "./views/Program/UpdateBudgetDetail";

import ClaimSummary from "./views/Claim/Summary";
import ClaimSummaryDetail from "./views/Claim/SummaryDetail";

import ClaimApproval from "./views/Claim/Approval";
import ClaimApprovalDetail from "./views/Claim/ApprovalDetail";
import ClaimApprovalDXM from "./views/Claim/ApprovalDXM";
import ClaimApprovalDXMDetail from "./views/Claim/ApprovalDXMDetail";
import multiUploadBukpot from "./views/Claim/multiUploadBukpot";
import MassUploadBupot from "./views/Claim/MassUploadBupot";
import MassUploadPayment from "./views/Claim/MassUploadPayment";

import Editclaim from "./views/Claim/Editclaim";
import EditclaimDetail from "./views/Claim/EditclaimDetail";

import Payment from "./views/Claim/Payment";
import PaymentDetail from "./views/Claim/PaymentDetail";

import Reject from "./views/Program/Reject";
import RejectDetail from "./views/Program/RejectDetail";

import ClaimReject from "./views/Claim/Reject";
import ClaimRejectDetail from "./views/Claim/RejectDetail";
import ReportProgram from "./views/ReportProgram/program";
import ReportProgramTraces from "./views/ReportProgram/programtraces";
import ReportAssignment from "./views/ReportProgram/assignment";
import ReportClaim from "./views/ReportProgram/claim";
import ReportForprincipal from "./views/ReportProgram/forprincipal";
import ReportClaimPrincipal from "./views/ReportProgram/claimprincipal";

import UploadBupot from "./views/Claim/Upload";
import UploadBupotDetail from "./views/Claim/UploadDetail";

import ReceiveAWB from "./views/Document/Receive";

import userlist from "./views/Setup/userList";
import userupdate from "./views/Setup/userUpdate";
import usernew from "./views/Setup/userNew";

import role from "./views/Setup/role";
import princ from "./views/Setup/principal";
import UploadEBupotNew from "./views/Claim/UploadEBupotNew";
import indexMultiApprove from "./views/Claim/multiApprove/indexMultiApprove";

// import ReceiveAWB from './views/Document/Receive'

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "pe-7s-bell",
    component: Dashboard,
    layout: "/admin",
  },
  // {
  //   path: "/changepass",
  //   name: "Change Password User",
  //   icon: "pe-7s-bell",
  //   component: changePass,
  //   layout: "/admin"
  // },
  {
    path: "/program/create",
    name: "Program",
    icon: "pe-7s-bell",
    component: Program,
    layout: "/admin",
  },
  {
    path: "/program/approval",
    name: "Approval",
    icon: "pe-7s-bell",
    component: Approval,
    layout: "/admin",
  },
  {
    path: "/program/summary",
    name: "Summary",
    icon: "pe-7s-bell",
    component: Summary,
    layout: "/admin",
  },
  {
    path: "/program/approval/:id",
    name: "Approval",
    icon: "pe-7s-bell",
    component: ApprovalDetail,
    layout: "/admin",
  },

  {
    path: "/program/updatebudget",
    name: "Update Budget",
    icon: "pe-7s-bell",
    component: UpdateBudget,
    layout: "/admin",
  },

  {
    path: "/program/updatebudget/:id",
    name: "Update Budget",
    icon: "pe-7s-bell",
    component: UpdateBudgetDetail,
    layout: "/admin",
  },

  {
    path: "/program/summary/:id",
    name: "Approval",
    icon: "pe-7s-bell",
    component: SummaryDetail,
    layout: "/admin",
  },
  {
    path: "/program/member",
    name: "Member",
    icon: "pe-7s-bell",
    component: Member,
    layout: "/admin",
  },
  {
    path: "/claim/summary",
    name: "Summary",
    icon: "pe-7s-bell",
    component: ClaimSummary,
    layout: "/admin",
  },
  {
    path: "/claim/approval",
    name: "Single Approve",
    icon: "pe-7s-bell",
    component: ClaimApproval,
    layout: "/admin",
  },
  {
    path: "/claim/multiapprove",
    name: "Multi Approve",
    icon: "pe-7s-bell",
    component: indexMultiApprove,
    layout: "/admin",
  },
  {
    path: "/claim/approval/:id",
    name: "Summary",
    icon: "pe-7s-bell",
    component: ClaimApprovalDetail,
    layout: "/admin",
  },

  {
    path: "/claim/editclaim",
    name: "Edit Claim",
    icon: "pe-7s-bell",
    component: Editclaim,
    layout: "/admin",
  },
  {
    path: "/claim/editclaim/:id",
    name: "Edit Claim",
    icon: "pe-7s-bell",
    component: EditclaimDetail,
    layout: "/admin",
  },

  {
    path: "/claim/approval-dxm",
    name: "Approval Claim",
    icon: "pe-7s-bell",
    component: ClaimApprovalDXM,
    layout: "/admin",
  },
  {
    path: "/claim/approval-dxm/:id",
    name: "Summary",
    icon: "pe-7s-bell",
    component: ClaimApprovalDXMDetail,
    layout: "/admin",
  },
  {
    path: "/claim/view/:id",
    name: "Summary",
    icon: "pe-7s-bell",
    component: ClaimSummaryDetail,
    layout: "/admin",
  },
  {
    path: "/claim/mass-upload-bupot",
    name: "Upload E-Bupot",
    icon: "pe-7s-bell",
    component: MassUploadBupot,
    layout: "/admin",
  },
  {
    path: "/claim/mass-upload-bupot-new",
    name: "Upload E-Bupot",
    icon: "pe-7s-bell",
    component: UploadEBupotNew,
    layout: "/admin",
  },
  {
    path: "/claim/mass-upload-payment",
    name: "Upload Payment",
    icon: "pe-7s-bell",
    component: MassUploadPayment,
    layout: "/admin",
  },
  {
    path: "/payment",
    name: "Payment",
    icon: "pe-7s-bell",
    component: Payment,
    layout: "/admin",
  },
  {
    path: "/payment/:id",
    name: "Payment",
    icon: "pe-7s-bell",
    component: PaymentDetail,
    layout: "/admin",
  },
  {
    path: "/reject",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: Reject,
    layout: "/admin",
  },
  {
    path: "/reject/:id",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: RejectDetail,
    layout: "/admin",
  },
  {
    path: "/claim/reject",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: ClaimReject,
    layout: "/admin",
  },
  {
    path: "/claim/reject/:id",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: ClaimRejectDetail,
    layout: "/admin",
  },
  {
    path: "/claim/upload",
    name: "Upload E-Bupot",
    icon: "",
    component: UploadBupot,
    layout: "/admin",
  },

  {
    path: "/claim/multiUploadBukpot",
    name: "Multi Upload E-Bupot",
    icon: "",
    component: multiUploadBukpot,
    layout: "/admin",
  },
  {
    path: "/claim/multiupload-bupot",
    name: "Upload E-Bupot",
    icon: "pe-7s-bell",
    component: UploadEBupotNew,
    layout: "/admin",
  },
  {
    path: "/claim/upload/:id",
    name: "Upload E-Bupot",
    icon: "",
    component: UploadBupotDetail,
    layout: "/admin",
  },
  {
    path: "/reportprogram/assignment",
    name: "Report Assignment",
    icon: "pe-7s-bell",
    component: ReportAssignment,
    layout: "/admin",
  },
  // {
  //   path: "/reportprogram/program",
  //   name: "Report Program",
  //   icon: "pe-7s-bell",
  //   component: ReportProgram,
  //   layout: "/admin",
  // },
  // {
  //   path: "/reportprogram/claim",
  //   name: "Report Claim",
  //   icon: "pe-7s-bell",
  //   component: ReportClaim,
  //   layout: "/admin",
  // },
  {
    path: "/reportprogram/claim-principal",
    name: "Report Claim",
    icon: "pe-7s-bell",
    component: ReportClaimPrincipal,
    layout: "/admin",
  },
  {
    path: "/reportprogram/progratraces",
    name: "Report Program",
    icon: "pe-7s-bell",
    component: ReportProgramTraces,
    layout: "/admin",
  },
  {
    path: "/reportprogram/forprincipal",
    name: "TRACES-Principal",
    icon: "pe-7s-bell",
    component: ReportForprincipal,
    layout: "/admin",
  },
  {
    path: "/document/receive",
    name: "Receive AWB",
    icon: "",
    component: ReceiveAWB,
    layout: "/admin",
  },
  {
    path: "/setup/user/userlist",
    name: "Ar Management Users",
    icon: "",
    component: userlist,
    layout: "/admin",
  },
  {
    path: "/setup/user/userupdate/:id",
    name: "Update User",
    icon: "",
    component: userupdate,
    layout: "/admin",
  },
  {
    path: "/setup/user/usernew",
    name: "New User",
    icon: "",
    component: usernew,
    layout: "/admin",
  },
  // {
  //   path: "/setup/user/changepass",
  //   name: "Change Password User",
  //   icon: "",
  //   component: changePass,
  //   layout: "/admin"
  // },

  {
    path: "/setup/master/role",
    name: "Role Master Data",
    icon: "",
    component: role,
    layout: "/admin",
  },
  {
    path: "/setup/master/principal",
    name: "Principal Master Data",
    icon: "",
    component: princ,
    layout: "/admin",
  },
];

export default dashboardRoutes;
